export class JSONRpc {
    jsonrpc: string;
    method: string;
    id: string;
    params: any;
    constructor(options: {
            jsonrpc?: string,
            method?: string,
            id?: string,
            params?: any
        } = {}) {
        this.jsonrpc = options.jsonrpc || '';
        this.method = options.method || '';
        this.id = options.id || '';
        this.params = options.params || {};
    }
}